export default __webpack_public_path__ + "static/media/nus01.35c22632.png";